var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50521 7.50326H7.97854L7.79188 7.32326C8.44521 6.56326 8.83854 5.57659 8.83854 4.50326C8.83854 2.10992 6.89854 0.169922 4.50521 0.169922C2.11188 0.169922 0.171875 2.10992 0.171875 4.50326C0.171875 6.89659 2.11188 8.83659 4.50521 8.83659C5.57854 8.83659 6.56521 8.44326 7.32521 7.78992L7.50521 7.97659V8.50326L10.8385 11.8299L11.8319 10.8366L8.50521 7.50326ZM4.50521 7.50326C2.84521 7.50326 1.50521 6.16326 1.50521 4.50326C1.50521 2.84326 2.84521 1.50326 4.50521 1.50326C6.16521 1.50326 7.50521 2.84326 7.50521 4.50326C7.50521 6.16326 6.16521 7.50326 4.50521 7.50326Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 4.83659H4.83854V6.16992H4.17188V4.83659H2.83854V4.16992H4.17188V2.83659H4.83854V4.16992H6.17188V4.83659Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.ed9fadddf965d793278bd1cf909b69d3.svg";
export { ForwardRef as ReactComponent };